import { render } from "./HeroSettingGeneralInfo.vue?vue&type=template&id=75ccddd7&scoped=true"
import script from "./HeroSettingGeneralInfo.vue?vue&type=script&lang=js"
export * from "./HeroSettingGeneralInfo.vue?vue&type=script&lang=js"

import "./HeroSettingGeneralInfo.vue?vue&type=style&index=0&id=75ccddd7&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ccddd7"]])

export default __exports__